var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 595.3",
    style: {
      enableBackground: "new 0 0 595.3 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:39.3672;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:15.625;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M544.7,510.5H50.6C22.7,510.5,0,487.8,0,459.9V135.4c0-27.9,22.7-50.6,50.6-50.6h494.1c27.9,0,50.6,22.7,50.6,50.6v324.5 C595.3,487.8,572.6,510.5,544.7,510.5z M50.6,124.2c-6.2,0-11.2,5-11.2,11.2v324.5c0,6.2,5,11.2,11.2,11.2h494.1 c6.2,0,11.2-5,11.2-11.2V135.4c0-6.2-5-11.2-11.2-11.2H50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,363.9c-30,0-58.2-11.7-79.4-32.9L22.7,135.3c-7.7-7.7-7.7-20.2,0-27.8c7.7-7.7,20.1-7.7,27.8,0L246,303.1 c27.6,27.6,75.6,27.6,103.2,0l195.6-195.7c7.7-7.7,20.1-7.7,27.8,0c7.7,7.7,7.7,20.1,0,27.8L377.1,331 C355.9,352.2,327.7,363.9,297.6,363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,476.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.6,470.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.542828f139c760022f680d676a6b5aca.svg";
export { ForwardRef as ReactComponent };